export const loadFromSessionStorage = (key: string): string | null => {
  if (typeof window !== 'undefined') {
    const item = sessionStorage.getItem(key);
    return item ?? null;
  }
  return null;
};

export const saveToSessionStorage = (key: string, value: string): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(key, value);
  }
};
